<template>
  <div class="yk-interactions-share-header yk-interactions-share clearfix">
    <div class="tea-question-side-wrapper">
      <div class="yk-el-aside">
        <div class="yk-el-aside-title">
          <i class="wl-icon-huodong" style="font-size:18px;"></i>
          <span>互动种类</span>
        </div>
        <el-checkbox-group v-model="checkList">
          <div
            class="yk-qu-con"
            v-for="(item,index) of interaction"
            :key="index"
            :class="{'active':icon==index}"
            @click="hanldClick(index,item)"
            >
            <el-checkbox :label="item.type" v-if="isShow" @click.stop.native="handleChecked" style="margin-left:5px;">&nbsp;</el-checkbox>
            <i class="wl-icon-xiaoyuan"></i>
            {{item.word}}
            <i class="wl-icon-xiangzuo right"></i>
            <p class="line-active"></p>
          </div>
        </el-checkbox-group>
      </div>
    </div>
    <div class="yk-interactions__showcases">
      <router-view></router-view>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
export default Vue.extend({
  name: "ShareManagementSource-list",
  props: {
    IsAll: {
      type: Boolean,
      default: false
    },
    schoolCourseId: {
      type: String,
      default: ""
    },
    courseId: {
      type: String,
      default: ""
    },
    userType: {
      type: [Number, String],
      default: 0
    },
    isShow: {
      type: Boolean,
      default: ""
    },
    importCourseVisible: {
      type: Boolean,
      default: ""
    }
  },
  created() {
    this.$router.push({
      name: "teaShareDiscussCourse",
      params: {}
    });
  },
  data() {
    return {
      iportCourseIds: [],
      interaction: [
        {
          word: "讨论",
          name: "teaShareDiscussCourse",
          type: "3"
        },
        {
          word: "投票",
          name: "teaShareVoteCourse",
          type: "6"
        },
        {
          word: "提问",
          name: "teaShareQuestion",
          type: "4"
        },
        {
          word: "测验",
          name: "teaShareTest",
          type: "10"
        },
        {
          word: "问卷调查",
          name: "teaShareSurveyCourse",
          type: "7"
        },
        {
          word: "头脑风暴",
          name: "teaShareBrainstormingCourse",
          type: "2"
        }
      ],
      icon: 0,
      checkList: []
    };
  },
  methods: {
    sureImport() {
      var that = this;
      if ((this.IsAll = true)) {
        that.sourceList_ = [];
      }
      this.$http
        .post("/api/partner/CourseSourceImport/importPrepare", {
          PrepareType: that.checkList,
          toCourseId: that.courseId,
          fromCourseIds: that.iportCourseIds
        })
        .then(rst => {
          if (rst.code > 0) {
            that.checkList = [];
            that.$message.success(rst.msg);
            that.importCourseVisible = false;
            that.getOff();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    getCourseIds(val) {
      var that = this;
      this.iportCourseIds = [];
      val.forEach(function(item) {
        that.iportCourseIds.push(item.Id);
      });
      console.log(that.iportCourseIds);
    },
    getOff() {
      this.importCourseVisible = false;
      this.$emit("offOver", false);
      this.$refs.childCourse.clearSection();
    },
    hanldClick(i, item) {
      debugger;
      this.icon = i;
      this.$router.push({
        name: item.name
      });
    },
    handleChecked(){
      
    }
  }
});
</script>

<style lang="scss" scoped>
  .yk-interactions__container {
    .el-table {
      th {
        background-color: #293140;
        //color: white;
      }
      tr {
        background-color: #3c4c66;
        //color: white;
      }
      td {
        background-color: #3c4c66;
        //color: white;
      }
    }
    .yk-interactions__showcases {
      margin: 0 auto;
    }
  }
  .yk-interactions-share {
    .yk-interactions__control-main {
      // .router-link-exact-active {
      //   //background-color: #374256;
      // }
      .linkActive {
        color: #409eff;
        //background-color: #374256;
      }
      .yk-interactions-share {
        display: block;
        text-align: center;
        text-decoration: none;
        //color: #fff;
        margin: 18px;
      }
    }
  }
  .yk-interactions-share-header {
    // height: calc(100vh - 170px);
    .tea-question-side-wrapper {
      float: left;
      color: #333;
      width: 260px;
      .yk-el-aside {
        .yk-el-aside-title {
          background: #f7f7f7;
          color: #333;
          height: 50px;
          line-height: 50px;
          // margin-bottom: 10px;
          font-size: 18px;
          padding-left: 19px;
          span {
            margin-left: 5px;
          }
        }
        .yk-qu-con {
          position: relative;
          display: flex;
          height: 50px;
          line-height: 50px;
          padding-left: 15px;
          color: #333;
          cursor: pointer;
          position: relative;
          .yk-title {
            font-size: 16px;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            width: 158px;
          }
          &:hover {
            background-color: #dde4eb;
            .line-active {
              display: block;
            }
          }
          .wl-icon-xiaoyuan {
            font-size: 36px;
            color: #333;
          }
          span {
            float: right;
            height: 18px;
            border: 1px solid #409eff;
            color: #409eff;
            line-height: 17px;
            margin-top: 18px;
            padding: 0 5px;
            border-radius: 9px;
          }
          .point-span {
            display: inline-block;
            width: 8px;
            height: 8px;
            border: 1px solid #fff;
            border-radius: 50%;
            margin: 20px 10px 0 34px;
          }
          .el-checkbox {
            position: absolute;
            left: 5px;
          }
          .el-checkbox__inner {
            background: #374256;
          }
        }
        .active {
          background-color: #dde4eb;
          .line-active {
            display: block;
          }
        }
        .line-active {
          background-color: #409eff;
          position: absolute;
          height: 100%;
          width: 3px;
          top: 0px;
          left: -1px;
          display: none;
        }
        .yk-add-group {
          margin-top: 20px;
          margin-bottom: 10px;
          text-align: center;
          cursor: pointer;
          font-size: 17px;
          color: #009688;
          i {
            font-weight: bolder;
            color: #409eff;
          }
        }
        .el-checkbox-group {
          font-size: inherit;
        }
      }
      .wl-icon-xiangzuo {
        transform: rotate(180deg);
        position: absolute;
        right: 20px;
        top: 0;
      }
    }
    .yk-interactions__showcases {
      margin-left: 260px;
    }
  }

  .yk-interactions__container {
    .el-table {
      th {
        background-color: #293140;
        //color: white;
      }
      tr {
        background-color: #3c4c66;
        //color: white;
      }
      td {
        background-color: #3c4c66;
        //color: white;
      }
    }
    .yk-interactions__showcases {
      margin: 0 auto;
    }
  }
  .yk-interactions-share {
    .yk-interactions__control-main {
      .linkActive {
        color: #409eff;
      }
      .yk-interactions-share {
        display: block;
        text-align: center;
        text-decoration: none;
        margin: 18px;
      }
    }
  }
</style>
